// Internal Errors

export const errorMessageInvalidMimeType = 'Invalid mime type.';
export const errorMessageFileDelete = 'File delete failed.';
